<script>
import Translatable from '@src/mixins/translatable.js'

export default {
  mixins: [
    Translatable
  ],
  props: {
    attraction: {
      type: Object,
      required: true
    },
  },
  computed: {
    backgroundImage() {
      const img = this.attraction.images.length ? this.attraction.images[0] : ""
      return {
        backgroundImage: `url(${process.env.VUE_APP_STATIC_URL}small_${img})`
      }
    },
  },
  methods: {
    capitalize(string) {
      return string.toLowerCase().replace(/(^|\s)\S/g, l => l.toUpperCase())
    }
  },
}
</script>

<template>
  <div class="card">
    <div :style="backgroundImage" class="card-image"></div>
    <div class="card-content">
      <p class="card-text">{{ capitalize(getTranslatedContent('title', attraction.content)) }}</p>
      <p class="card-price">{{ attraction.priceAdult | KC }}</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.card {
  display: flex;
  align-items: center;
  height: 58px;
  background-color: $white;
  border-bottom: 2px solid $light-gray;
  padding: 10px 5px;
  font-family: Open Sans, sans-serif;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
}

.card-image {
  height: 57px;
  width: 97px;
  border-radius: 5px;
  margin-right: 12px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.card-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 69%;
}

.card-text {
  width: 165px;
}

.card-price {
  margin-right: 20px;
}

@media only screen and (min-width: $mobile-screen-width) and (max-width: $container-width-xs) {

  .card-content {
    display: flex;
    flex-direction: column;
    width: auto;
    width: 100%;
  }

  .card-text {
    width: 75%;
  }

  .card-price {
    font-family: Open Sans Bold, sans-serif;
    font-weight: bold;
    width: 100%;
    text-align: right;
    margin-right: 40px;
  }
}
</style>
